import { render, staticRenderFns } from "./KataSandi.vue?vue&type=template&id=f4f7dd66&scoped=true"
import script from "./KataSandi.vue?vue&type=script&lang=js"
export * from "./KataSandi.vue?vue&type=script&lang=js"
import style0 from "./KataSandi.vue?vue&type=style&index=0&id=f4f7dd66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4f7dd66",
  null
  
)

export default component.exports